<template>
    <div>
        <div class="modal fade" id="ioniconModal" tabindex="-1" role="dialog" aria-labelledby="ioniconModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="ioniconModalLabel">Select Icon</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">
                        <ionicons @iconSelected="onIconSelected"></ionicons>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn modal-btn btn-primary" @click="yesHandler">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Ionicons from "../../components/Ionicons.vue";
    export default {
        name: 'IoniconModal',
        components: {Ionicons},
        props: {
            yesEvent: Function,
            tab: Object
        },
        data () {
            return {
                model: webase.model,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('ioniconModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {
                // call the parent's "yesEvent"
                if(this.yesEvent) {
                    this.yesEvent()
                }
                // hide the modal
                this.noHandler()
            },
            onIconSelected(icon) {
                this.tab.icon = icon.name
            }
        }
    }
</script>
